module.exports = __webpack_public_path__ + "img/40.34113c5a.png";